import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Shield, Lock, Layers, Briefcase, Zap, Search } from 'lucide-react';

export default function UseCaseEnterprise() {
  return (
    <SubpageTemplate 
      title="Enterprise Solutions"
      subtitle="Scalable Synthesis"
      description="Modernize internal tools and digital infrastructure with the speed of AI. Yacht Labs provides the security and scalability required for global organizations."
      icon={Briefcase}
      features={[
        {
          title: "Internal Tooling",
          description: "Synthesize dashboards, admin panels, and employee portals in record time.",
          icon: Layers
        },
        {
          title: "SSO & Security",
          description: "Enterprise-grade authentication and data residency compliance built-in from the start.",
          icon: Shield
        },
        {
          title: "Legacy Bridge",
          description: "Connect modern AI-synthesized interfaces to your existing enterprise data lakes and APIs.",
          icon: Search
        }
      ]}
    />
  );
}
